<template>
  <div
    class="container"
  >
    <Scroller
      ref="scroller"
      class="project-container"
    >
      <ScrollerSlide
        v-for="(image, index1) in studios"
        :key="image.id"
        class="md-layout md-layout-item slide"
      >
        <div
          :class="{ 'active': currentIndex == index1 }"
          class="project-image-size "
          @click="setActive(index1)"
        >
          <img :src="previewImage(image.field_preview)">
          <div class="project-name">
            <span>{{ image.title }}</span>
          </div>
        </div>
      </ScrollerSlide>
    </Scroller>
    <a
      class="prev"
      href="#"
      @click="slideBackwards"
    >&#10094;</a>
    <a
      class="next"
      href="#"
      @click="slideForwards"
    >&#10095;</a>
  </div>
</template>

<script>
import { Scroller, ScrollerSlide } from '@inniti/vue-horizontal-scroller';

export default {
  name: 'StudioProjectList',
  components: {
    Scroller,
    ScrollerSlide
  },
  props: {
    studioProjects: {
      type: Array,
      required: true
    },
  },
  data() {
    return {
      currentIndex: 0,
      studios: [],
      index: 0
    }
  },
  watch: {
    studioProjects(value) {
      if (value.length) {
        this.studios = value
      }
      this.setActive(this.index)
    }
  },
  methods: {
    previewImage(image) {
      return image.length ? image : require('@/assets/project-dummy.jpeg')
    },
    setActive(value) {
      this.currentIndex = value
      this.$emit('current-index', value)
    },
    slideBackwards() {
      this.$refs.scroller.slideBackwards();
    },
    slideForwards() {
      this.$refs.scroller.slideForwards();
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  position: relative;
  background-color: #6a0043;
  min-height: 280px;
  margin-bottom: 13px;
  .slide {
    &:not(:last-child) {
      margin-right: 36px;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .project-container {
    margin: auto 13% auto 10%; 
    .project-image-size {
      margin-top: 32px;
      &:not(:last-child) {
        margin-right: 36px;
      }
      &:hover {
        cursor: pointer;
      }
      &.active {
        border: 1px solid $color-white;
      }
      
    }
  }
}
 .fade-enter-active, .fade-leave-active {
    transition: all 0.9s ease;
    overflow: hidden;
    visibility: visible;
    position: absolute;
    width:100%;
    opacity: 1;
}
 .fade-enter, .fade-leave-to {
    visibility: hidden;
    width:100%;
    opacity: 0;
}
 img {
  width:100%;
  height:100%;
}
.project-image-size {
  width:200px;
  height: 200px !important;
  margin-bottom: 20px;
  .project-name {
    position: relative;
    top: -39px;
    background-color: #000000;
    opacity: 0.8;
    height: 40px;
    color: #ffffff;
    span {
      font-weight: bold;
      position: relative;
      top: 10px;
    }
  }
}

 .prev, .next {
    cursor: pointer;
    position: absolute;
    top: 40%;
    width: auto;
    padding: 16px;
    color: white !important;
    font-weight: bold;
    transition: 0.7s ease;
    border-radius: 0 4px 4px 0;
    text-decoration: none;
    user-select: none;
    font-size: 40px;
}
.next {
  right: 10px;
}
.prev {
  left: 20px;
}
.prev:hover, .next:hover {
  text-decoration: none;
}
 
@media only screen and (max-width: 600px) {
  .project-image-size {
    height: 200px !important;
    margin-bottom: 40px;
  }
}

@media only screen and (max-width: 832px) and (orientation: landscape) {
  .project-image-size{
    margin-bottom: 20px;
  }
}


@media only screen and (max-width: 1024px) and (max-width: 1024px) {
  .project-image-size {
    margin-bottom: 20px;
  }
}
</style>